import React from 'react';
import { CheckCircle, AlertTriangle, XCircle, CloudLightning } from 'lucide-react';

export type SoaringVerdict = 'favorable' | 'marginal' | 'unflyable' | 'storm-risk';

interface SoaringBadgeProps {
  verdict: SoaringVerdict;
  size?: 'sm' | 'md' | 'lg';
  showIcon?: boolean;
}

const verdictConfig = {
  favorable: {
    label: 'Bonne journee',
    labelFr: 'Bonne journee',
    bg: 'color-mix(in srgb, var(--success-green) 16%, transparent)',
    border: 'color-mix(in srgb, var(--success-green) 45%, transparent)',
    color: 'var(--success-green)',
    icon: <CheckCircle size={16} />,
  },
  marginal: {
    label: 'Journee moyenne',
    labelFr: 'Journee moyenne',
    bg: 'color-mix(in srgb, var(--warning-orange) 16%, transparent)',
    border: 'color-mix(in srgb, var(--warning-orange) 45%, transparent)',
    color: 'var(--warning-orange)',
    icon: <AlertTriangle size={16} />,
  },
  unflyable: {
    label: 'Non favorable',
    labelFr: 'Non favorable',
    bg: 'color-mix(in srgb, var(--danger-red) 14%, transparent)',
    border: 'color-mix(in srgb, var(--danger-red) 40%, transparent)',
    color: 'var(--danger-red)',
    icon: <XCircle size={16} />,
  },
  'storm-risk': {
    label: 'Risque orage',
    labelFr: 'Risque orageux',
    bg: 'color-mix(in srgb, var(--purple-cloud) 16%, transparent)',
    border: 'color-mix(in srgb, var(--purple-cloud) 45%, transparent)',
    color: 'var(--purple-cloud)',
    icon: <CloudLightning size={16} />,
  },
};

const sizeClasses = {
  sm: 'text-xs px-2 py-0.5 gap-1',
  md: 'text-sm px-3 py-1 gap-1.5',
  lg: 'text-base px-4 py-2 gap-2',
};

export default function SoaringBadge({ verdict, size = 'md', showIcon = true }: SoaringBadgeProps) {
  const config = verdictConfig[verdict];
  return (
    <span
      className={`inline-flex items-center font-semibold rounded-full ${sizeClasses[size]}`}
      style={{
        backgroundColor: config.bg,
        border: `1px solid ${config.border}`,
        color: config.color,
      }}
    >
      {showIcon && config.icon}
      {config.labelFr}
    </span>
  );
}
